import $ from 'jquery'

/**
 * Adapter for Bootstrap's typeahead plugin.
 * @param {HTMLElement} element - The element to which the adapter is applied.
 * @param {Object} options - Options for the typeahead plugin.
 * @returns {Function} - A callback to destroy the typeahead plugin on this particular element.
 */
export default (
  element: HTMLElement,
  options: Bootstrap3Typeahead.Options
): (() => void) => {
  $(element).typeahead(options)

  return (): void => {
    $(element).typeahead('destroy')
  }
}
